(function (upp) {
    'use strict';

    upp.config(['$routeProvider',
        function ($routeProvider) {
            var resolver = {
                resolve : $routeProvider.ResolverFactory.moduleIsActivated("pointscard").resolver
            };

            $routeProvider
                .when('/pointscard', {
                    templateUrl: require('../templates/points-list.html'),
                    resolve: resolver
                })
                .when('/pointscard/points-redeem/:id', {
                    templateUrl: require('../templates/points-redeem.html'),
                    resolve: resolver
                })
                .when('/pointscard/points-assign', {
                    templateUrl: require('../templates/points-assign.html'),
                    resolve: resolver
                })
                .when('/pointscard/points-asign', {
                    templateUrl: require('../templates/points-assign.html'),
                    resolve: resolver
                })


        }]);

})(upp);



// WEBPACK FOOTER //
// ./src/app/modules/points/routes/points-routes.js